import { createSelector } from 'reselect';
const getPageConf = createSelector([
    (state) => state.page.template,
    (state) => state.page.size,
    (state) => state.page.orientation,
], (template, size, orientation) => {
    return template.pageSize && template.pageSize[size][orientation];
});
export const getHeader = createSelector([getPageConf, (state) => state.config.defaultHeader], (pageConf, defaultHeader) => {
    return pageConf?.header ? pageConf.header : defaultHeader || [];
});
export const getFooter = createSelector([getPageConf, (state) => state.config.defaultFooter], (pageConf, defaultFooter) => {
    return pageConf?.footer ? pageConf.footer : defaultFooter || [];
});
//# sourceMappingURL=selectors.js.map